import FileCopyOutlineIcon from "~icons/material-symbols/file-copy-outline";
import { useLiveQuery } from "dexie-react-hooks";
import _ from "lodash";
import { memo, useCallback, useRef } from "react";
import { Virtuoso, VirtuosoHandle } from "react-virtuoso";
import { EmptyPlaceholder } from "../../../components/EmptyPlaceholder";
import { LoadingContainer } from "../../../components/Loading";
import { useAppDataFields } from "../../../hooks/useAppData";
import { SearchHistory, localDbStore } from "../../../store/LocalDbStore";
import { RenderItem } from "./RenderItem";

type SuggestionSearchHistoryProps = {
  appId: string;
  userId: string;
};
const getSearchHistoryByUserId = (userId: string, count: number = 10) =>
  localDbStore.histories.where("userId").equalsIgnoreCase(userId).reverse().limit(count).toArray();

const NoSearchHistory = () => (
  <EmptyPlaceholder text="No search history found." icon={<FileCopyOutlineIcon className="text-[48px]" />} />
);

const virtuosoComponents = { EmptyPlaceholder: NoSearchHistory };

export const SuggestionSearchHistory = memo(({ userId, appId }: SuggestionSearchHistoryProps) => {
  const [, updateDataFields] = useAppDataFields<Record<string, any>>(appId, [
    "searchText",
    "searchType",
    "workspaceId",
    "metadataTags",
  ]);

  const searchHistories = useLiveQuery(() => getSearchHistoryByUserId(userId), [userId]);

  const virtuosoRef = useRef<VirtuosoHandle>(null);

  const onSearchAgain = useCallback(
    (history: SearchHistory) => {
      updateDataFields({
        searchText: history.searchText,
        searchType: history.searchType,
        workspaceId: history.workspaceId,
        metadataTags: history.tags ?? [],
      });
    },
    [updateDataFields]
  );
  const itemContent = useCallback(
    (index: number, data: SearchHistory) => <RenderItem idx={index} item={data} context={{ onSearchAgain }} />,
    [onSearchAgain]
  );
  return (
    <LoadingContainer isLoading={_.isNil(searchHistories)}>
      <Virtuoso
        ref={virtuosoRef}
        style={{ height: "100%" }}
        data={searchHistories ?? []}
        itemContent={itemContent}
        components={virtuosoComponents}
      />
    </LoadingContainer>
  );
});
